<template>
  <div id="app" class="appbox">
    <router-view :islogin="islogin" :accountbase="account" />
    <div class="icptxt">
      <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" style="color: #666;">浙ICP备2021030995号</a>
    </div>
  </div>
</template>
<style>
@import "./assets/css/weui.min.css";
</style>
<style lang="scss">
@import "./assets/sass/style.scss";
</style>
<script>
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      mywechatinfo: {},
      account: {},
      islogin: false,
    }
  },
  watch: {
    '$route'(to, from) {
      let mask = document.getElementsByClassName("weui-mask")[0];
      let dialog = document.getElementsByClassName("weui-dialog")[0];
      let picker = document.getElementsByClassName("weui-picker")[0];
      let toptips = document.getElementsByClassName("weui-toptips")[0];
      let toast = document.getElementsByClassName("weui-loading_toast")[0];

      if (mask && dialog) {
        // //console.log('mask && dialog')
        var btn = document
          .getElementsByClassName("weui-dialog")[0]
          .getElementsByClassName("weui-dialog__btn")[0];
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        btn.dispatchEvent(e);
      }
      if (mask && picker) {
        //console.log('mask && picker')
        var btn = document
          .getElementsByClassName("weui-picker")[0]
          .getElementsByClassName("weui-picker__action")[0];
        var btn1 = document
          .getElementsByClassName("weui-picker")[0]
          .getElementsByClassName("weui-icon-btn_close")[0];
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        if (btn) {
          btn.dispatchEvent(e);
        }
        if (btn1) {
          btn1.dispatchEvent(e);
        }
      }
      if (toptips) {
        // //console.log('toptips')
        toptips.hide();
      }
      if (toast) {
        // //console.log('toast')
        toast.hide()
      }
    }
  },
  created() {
    let vm = this;
    if (MYTEST) {
      vm.getAreaApi();
      vm.getAccount();
    } else {
      // alert('2')
      vm.ajax("wechat/info", "get", '', e => {
        if (e.data && e.data.openid) {
          // alert('3')
          vm.mywechatinfo = e.data;
          // vm.getjsapi();
          // vm.getToken();
          let href = window.location.href;
          // console.log(vm.$route.redirectedFrom)
          if (vm.$route.redirectedFrom && vm.$route.redirectedFrom == '/') {
            let hrefArr = href.split('#');
            href = hrefArr[0]
            // console.log('444444',href)
          }
          localStorage.setItem('shareUrl', href);

          vm.getAreaApi();

          vm.getAccount();
        } else {
          // console.log(vm.$route)
          let fullPath = vm.$route.fullPath;
          let u = fullPath.substr(1, fullPath.length - 1)
          // console.log(API_URL + 'wechat/oauth?u='+u);
          // return;
          window.location.href = HOST + '/wechat?u=' + u;
        }
      })
    }
  },
  methods: {
    getAreaApi() {
      let vm = this;
      vm.ajax("area", "get", '', e => {
        app.area = e.data;
      })
    },
    getAccount() {
      let vm = this;
      vm.ajax("account", "get", '', e => {
        ISLOGIN = true;
        vm.islogin = true;
        vm.account = e.data;
        // console.log(vm.$route)
        if (e.data && e.data.account && vm.$route && (vm.$route.name == 'register' || vm.$route.name == 'login')) {
          vm.$router.replace('/')
        }
        // if(MYTEST){

        // }else{
        //     vm.getjsapi();
        // }
      }, vm.$route)
    },
    // getjsapi(){
    //     let vm = this;
    //     //   console.log(localStorage.getItem('shareUrl'))
    //     let href = localStorage.getItem('shareUrl');
    //     let url=encodeURIComponent(href)
    //     vm.ajax("wechat/jsdk", "get", 'url='+url, e => {
    //         let data = e.data;
    //         console.log(data);
    //         wx.config({
    //             debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //             appId: data.app_id, // 必填，公众号的唯一标识
    //             timestamp: data.timestamp, // 必填，生成签名的时间戳
    //             nonceStr: data.nonce_str, // 必填，生成签名的随机串
    //             signature: data.signature,// 必填，签名
    //             jsApiList: [
    //             'chooseWXPay',
    //             'updateAppMessageShareData',
    //             'updateTimelineShareData'
    //             ] // 必填，需要使用的JS接口列表
    //         });
    //         // vm.share();
    //     })
    // },
    // share(){
    //     let vm = this;
    //     wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    //         let title = "衣印";
    //         let desc = "恋他，就为他洗衣！";
    //         let logo = require('./assets/img/logo.jpg');
    //         let time = new Date().getTime();
    //         let shareurl = window.location.href.split('#')[0]+'#/register?code='+vm.account.code+'&time='+time;
    //         console.log('shareurl',shareurl);
    //         wx.updateAppMessageShareData({ 
    //             title: title, // 分享标题
    //             desc: desc, // 分享描述
    //             link: shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //             imgUrl: logo, // 分享图标
    //             success: function () {
    //                 // 设置成功
    //             }
    //         })
    //         wx.updateTimelineShareData({ 
    //             title: title, // 分享标题
    //             desc: desc, // 分享描述
    //             link: shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //             imgUrl: logo, // 分享图标
    //             success: function () {
    //                 // 设置成功
    //             }
    //         })
    //     });
    // },
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue